import { createContext, useContext } from 'react';

import { isStringEmpty } from '../utils/helpers';

export interface ClientContextProps {
  accessToken: string;
  basePath?: string;
}

export const ClientContext = createContext<ClientContextProps>({
  accessToken: '',
});

export default function useClientContext() {
  const context = useContext(ClientContext);
  if (!context) {
    throw new Error('useClientContext must be used within an ClientProvider');
  }

  if (isStringEmpty(context.accessToken)) {
    throw new Error('ClientProvider must be used with an authToken and apiUrl');
  }

  return context;
}
